import React from "react";
import { ShinyBanner } from "components";
import RequestBoostButton from "components/subscription-addons/RequestBoostButton";

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  boost: "REQUESTS_BOOST_1M" | "REQUESTS_BOOST_300K";
  successCallbackPath: string;
  cancelCallbackPath: string;
  onBehalfWorkspaceId?: string;
}

const RequestBoostBanner = ({
  boost,
  successCallbackPath,
  cancelCallbackPath,
  onBehalfWorkspaceId,
  ...rest
}: Props) => {
  return (
    <>
      <ShinyBanner
        title="Keep your projects rolling"
        subtitle={
          boost === "REQUESTS_BOOST_1M"
            ? "Don't let limits hold you back – supercharge your projects with an extra 1 million requests for 79 EUR"
            : "Don't let limits hold you back – supercharge your projects with an extra 300,000 requests for 29 EUR"
        }
        footnotes={`* Purchasing "Requests Boost" increases the requests limit for the subscription for a single day. Used requests are reset at midnight UTC. The quoted price does not include taxes.`}
        cta={
          <RequestBoostButton
            successCallbackPath={successCallbackPath}
            cancelCallbackPath={cancelCallbackPath}
            onBehalfWorkspaceId={onBehalfWorkspaceId}
            style={{ width: "160px" }}
            boost={boost}
            data-testid="requests-boost"
          />
        }
        variant="dark"
        {...rest}
      ></ShinyBanner>

      <style jsx>{``}</style>
    </>
  );
};

export default RequestBoostBanner;
